import '@marketingtech/launch-code/dist/main.min.js'

function setDefaultValue () {
    window.digitalData._set(
        'digitalData.page.pageInfo.siteSection',
        'adobe.io:apis:photo-imaging-api'
    )
    const lang = navigator.language.toLowerCase()
    window.digitalData._set(
        'digitalData.page.pageInfo.language',
        lang
    )
    window.digitalData._set(
        'digitalData.page.pageInfo.legacyMarketSegment',
        'io'
    )
    window.digitalData._set(
        'digitalData.page.pageInfo.productName',
        'Photoshop API'
    )
}

function sendPageName (pageName) {
    setDefaultValue()

    window.digitalData._delete(
        'digitalData.page.pageInfo.pageName'
    )
    window.digitalData._set(
        'digitalData.page.pageInfo.pageName',
        `adobe.io:apis:creativecloud:photo-imaging-api:api-demo:${pageName}`
    )
    window._satellite.track('state', {
        digitalData: window.digitalData._snapshot()
    })
    return true
}

function sendEventName (type, action) {
    setDefaultValue()

    window.digitalData._delete(
        'digitalData.primaryEvent.eventInfo.eventName'
    )
    window.digitalData._set(
        'digitalData.primaryEvent.eventInfo.eventName',
        `${type} - ${action}`
    )
    window._satellite.track('event', {
        digitalData: window.digitalData._snapshot()
    })
    return true
}

function sendEvent (event) {
    // action: 'upload', // action: 'api.psActions',
    // file: uploadedFile,
    // page: page,
    // storage: `${ut ? 'cc' : 'aperitif'}`,
    // response: `${customFiles ? true : false}`,
    // elapsedTime: seconds

    try {
        setDefaultValue()
        switch (event.action) {
            case "api.psActions":
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.file.size`,
                    getFileSizeInMb(event.file && event.file.size)
                )
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.elapsedTime`,
                    getElapsedTime(event.elapsedTime)
                )
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.response`,
                    event.response
                )
                break;
            case "upload":
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.file.size`,
                    getFileSizeInMb(event.file && event.file.size)
                )
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.file.type`,
                    event.file && event.file.type || event.file
                )
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.file.elapsedTime`,
                    getElapsedTime(event.elapsedTime)
                )
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.file.storage`,
                    event.storage
                )
                window.digitalData._set(
                    `digitalData.cis.easybake.${event.action}.file.response`,
                    event.response
                )
                break;
            default:
                break;
        }

        window.digitalData._set(
            'digitalData.primaryEvent.eventInfo.eventName',
            event.action
        )
        window._satellite.track('event', {
            digitalData: window.digitalData._snapshot()
        })

        switch (event.action) {
            case "api.psActions":
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.file.size`
                )
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.elapsedTime`
                )
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.response`
                )
                break;
            case "upload":
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.file.size`
                )
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.file.type`
                )
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.file.elapsedTime`
                )
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.file.storage`
                )
                window.digitalData._delete(
                    `digitalData.cis.easybake.${event.action}.file.response`
                )
                break;
            default:
                break;
        }

        window.digitalData._delete(
            'digitalData.primaryEvent.eventInfo.eventName'
        )
        return true
    } catch (e) {
        console.log(e)
    }
}


function getFileSizeInMb(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return 'n/a'
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
    if (i === 0) return `${bytes} ${sizes[i]})`
    const mbSize = (bytes / (1024 ** i)).toFixed(1)
    switch (true) {
        case (mbSize < 1):
        case (mbSize > 10): //KB
            return '0-1'
        case (mbSize < 2):
            return '1-2'
        case (mbSize < 3):
            return '2-3'
        case (mbSize < 4):
            return '3-4'
        case (mbSize < 5):
            return '4-5'
        case (mbSize < 6):
            return '5-6'
        case (mbSize < 7):
            return '6-7'
        case (mbSize < 8):
            return '7-8'
        case (mbSize < 9):
            return '8-9'
        case (mbSize < 10):
            return '9-10'
        default:
            return 'n/a'
    }
}

function getElapsedTime(sec) {
    switch (true) {
        case (sec < 10):
            return sec
        case (sec < 20):
            return '10-20'
        case (sec < 30):
            return '20-30'
        case (sec < 60):
            return '30-60'
        case (sec < 90):
            return '60-90'
        case (sec < 120):
            return '90-120'
        default:
            return 'n/a'
    }
}


export default { sendPageName, sendEventName, sendEvent, getFileSizeInMb, getElapsedTime }
